import React, { useState, useEffect, useRef } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Select from "@mui/material/Select";
import RefreshIcon from "assets/svgIcons/ResendIcon";
import SearchIcon from "assets/svgIcons/SearchIcon";
import CloseIcon from "assets/svgIcons/CloseIcon";
import DownloadIcon from "assets/svgIcons/DownloadDownArrowIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  ADMIN_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import Box from "@mui/material/Box";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  Container,
  Wrapper,
  Header,
} from "pages/Admin/Manifest/ManifestStyled";
import moment from "moment";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { uuid } from "_helperFunctions/uuid";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

export const Manifest = () => {
  const { t } = useTranslation();
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  
  const { countMatch } = useHookstate(ADMIN_GLOBAL_STATE);
  const dispatch = useDispatch();
  const [manifestListData, setManifestListData] = useState([]);
  const [forXml, setForXml] = useState(true);
  const [forList, setForList] = useState(false);
  const [rowId, setRowId] = useState();
  const [openDismiss, setOpenDismiss] = useState(false);
  const [zoom, setZoom] = useState([]);
  const [manifestStatus, setManifestStatus] = useState(false);
  const handleClose = () => setOpenDismiss(false);
  const handleOpen = (rowID, params) => {
    setRowId(rowID);
    setZoom(params);
    setOpenDismiss(true);
  };

  const countReference = useRef(0);
  const [text, setText] = useState("");
  const {
    getSiteSettingStateAction,
    getPaceManifestStateAction,
    getMessageManifestStateAction,
    getLanguageManifestStateAction,
    getSimpleCarManifestStateAction,
    getManifestListStateAction,
    getSimpleCarListState,
    getLanguageListState,
    getPaceListState,
    getMessageListState,
    getSettingListState,
  } = useSelector((state) => state.commonReducers) || [];

  let SS_XML = "SiteSettings.xml";
  let PACE_XML = "Pace.xml";
  let MSG_XML = "Messages.xml";
  let LANG_XML = "LanguageSettings.xml";
  let SCA_XML = "SimpleCarAhead.xml";
  let MANIFEST_LIST = "Manifest List";
  const [optionManifest, setOptionManifest] = React.useState("");
  const handleChange = (event) => {
    setOptionManifest(event.target.value);
    setText("");
  };

  let htmlData = null;
  //#########################Highlight the text for XML Start#########################################################//
  function getHighlightedText(textData, highlight) {
    var parts = textData?.split(new RegExp(`(${highlight})`, "gi"));
    htmlData = textData;
    return parts?.map((part, index) => (
      <React.Fragment key={index}>
        {part?.toLowerCase() === highlight?.toLowerCase() &&
          highlight.length >= 2 ? (
          <b style={{ backgroundColor: "#e8bb49" }}>{part}</b>
        ) : (
          part
        )}
      </React.Fragment>
    ));
  }
  //#########################Highlight the text for XML End#########################################################//
  //#########################Highlight the text for Zip Content Start#########################################################//
  function getHighlightedText1(textData, highlight) {
    var parts = textData?.split(new RegExp(`(${highlight})`, "gi"));

    return parts?.map((part, index) => {
      return (
        <React.Fragment key={index}>
          {part?.toLowerCase() === highlight?.toLowerCase() &&
            highlight.length >= 2 ? (
            <mark id="searchHighlight" style={{ backgroundColor: "#e8bb49" }}>
              {part}
            </mark>
          ) : (
            part
          )}
        </React.Fragment>
      );
    });
  }
  //#########################Highlight the text for Zip Content End#########################################################//
  //######################counts the number of occurrences of a given highlight in a text string###########################//
  const getHighlightedTextCount = (text, highlight) => {
    const regex = new RegExp(highlight, "gi");
    const matches = text.match(regex);
    return matches ? matches.length : 0;
  };

  useEffect(() => {
    if (text.length >= 2 && htmlData) {
      //####expression to perform a case-insensitive global search for text within htmlData####//
      const regex = new RegExp(text, "gi");
      const matches = htmlData?.match(regex) || [];
      let manCount = matches?.length;
      countMatch.set(manCount);
    } else if (
      optionManifest === "Manifest List" &&
      manifestListData &&
      manifestListData.length !== 0 &&
      text.length >= 2 &&
      !openDismiss
    ) {
      let count = 0;
      manifestListData.forEach((row) => {
        count += getHighlightedTextCount(row?.Name, text);
        count += getHighlightedTextCount(row?.Version.toString(), text);
        count += getHighlightedTextCount(row?.CreatedByUser, text);
        count += getHighlightedTextCount(
          moment(row?.CreationDateInUtc).format("DD-MMM-YYYY HH:mm:ss"),
          text
        );
      });
      countMatch.set(count);
    } else if (
      optionManifest === "Manifest List" &&
      manifestListData &&
      manifestListData.length !== 0 &&
      text.length >= 2 &&
      openDismiss &&
      zoom &&
      zoom?.ZipContents !== 0
    ) {
      let firstCount = 0;
      let secondCount = 0;
      manifestListData.forEach((row) => {
        firstCount += getHighlightedTextCount(row?.Name, text);
        firstCount += getHighlightedTextCount(row?.Version.toString(), text);
        firstCount += getHighlightedTextCount(row?.CreatedByUser, text);
        firstCount += getHighlightedTextCount(
          moment(row?.CreationDateInUtc).format("DD-MMM-YYYY HH:mm:ss"),
          text
        );
      });
      zoom?.ZipContents?.forEach((item) => {
        secondCount += getHighlightedTextCount(item?.Name, text);
        secondCount += getHighlightedTextCount(
          moment(item?.LastModifiedDate).format("DD-MMM-YYYY HH:mm:ss"),
          text
        );
      });
      countMatch.set(firstCount + secondCount);
    } else {
      countMatch.set(0);
    }
  }, [text, htmlData, manifestListData, zoom, openDismiss]);
  //######################counts the number of occurrences of a given highlight in a text string###########################//

  //#########################Highlight the text for List Start#########################################################//
  function highlightedHTML(html, highlight) {
    htmlData = html;

    const regex = new RegExp(highlight, "gi");

    const highlightedHtml =
      highlight?.toLowerCase() && highlight.length >= 2
        ? html.replace(regex, `<b class="highlight">$&</b>`)
        : html;
    return (
      <div
        id="severalListData"
        dangerouslySetInnerHTML={{ __html: highlightedHtml }}
      />
    );
  }
  //#########################Highlight the text for List End#########################################################//
  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSiteSettingListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getPaceManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getPaceListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getMessageManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getMessageListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getManifestListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getLanguageManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getLanguageListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSimpleCarManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSimpleCarListServices(siteId.get()));
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSiteSettingListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getPaceManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getPaceListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getMessageManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getMessageListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getManifestListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getLanguageManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getLanguageListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSimpleCarManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSimpleCarListServices(siteId.get()));
    setOptionManifest("");
    setForXml(true);
    setForList(false);
  }, [siteId.get()]);

  useEffect(() => {
    const rowss =
      getManifestListStateAction && getManifestListStateAction?.length !== 0
        ? getManifestListStateAction?.map((row, i) => {
          return {
            ...row,
            id: uuid(),
          };
        })
        : "";
    setManifestListData(rowss);
  }, [getManifestListStateAction]);

  const actionButton = (params) => [
    <div className="action-btn">
      <ZoomInIcon
        color="#FA3C30"
        width="14px"
        height="16px"
        className="delete-icon"
        style={{ cursor: "pointer" }}
        onClick={() => handleOpen(params.id, params)}
      />
    </div>,
  ];

  const setToHighlight = (e) => {
    setText(e);
  };

  const xmlHandle = () => {
    setForXml(true);
    setForList(false);
    setText("");
  };
  const listHandle = () => {
    setForList(true);
    setForXml(false);
    setText("");
  };

  const refresh = () => {
    setOptionManifest("");
    setForXml(true);
    setForList(false);
    setManifestStatus(true);
    dispatch(COMMON_SERVICES.getSiteSettingManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getPaceManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getMessageManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getLanguageManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSimpleCarManifestServices(siteId.get()));
    dispatch(COMMON_SERVICES.getManifestListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSimpleCarListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getLanguageListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getPaceListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getMessageListServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSiteSettingListServices(siteId.get())).then(
      () => {
        setManifestStatus(false);
      }
    );
  };
  const blankText = () => {
    setText("");
  };

  return (
    <Container>
      <Header>
        <FormControl sx={{ minWidth: 120 }} size="small">
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={optionManifest}
            onChange={handleChange}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            IconComponent={KeyboardArrowDownIcon}
          >
            <MenuItem value="">
              <em>Select...</em>
            </MenuItem>
            {getSiteSettingStateAction &&
              getSiteSettingStateAction?.length !== 0 ? (
              <MenuItem value={SS_XML}>{SS_XML}</MenuItem>
            ) : (
              ""
            )}
            {getPaceManifestStateAction &&
              getPaceManifestStateAction?.length !== 0 ? (
              <MenuItem value={PACE_XML}>{PACE_XML}</MenuItem>
            ) : (
              ""
            )}
            {getMessageManifestStateAction &&
              getMessageManifestStateAction?.length !== 0 ? (
              <MenuItem value={MSG_XML}>{MSG_XML}</MenuItem>
            ) : (
              ""
            )}
            {getManifestListStateAction &&
              getManifestListStateAction?.length !== 0 ? (
              <MenuItem value={MANIFEST_LIST}>{MANIFEST_LIST}</MenuItem>
            ) : (
              ""
            )}
            {getLanguageManifestStateAction &&
              getLanguageManifestStateAction?.length !== 0 ? (
              <MenuItem value={LANG_XML}>{LANG_XML}</MenuItem>
            ) : (
              ""
            )}
            {getSimpleCarManifestStateAction &&
              getSimpleCarManifestStateAction?.length !== 0 ? (
              <MenuItem value={SCA_XML}>{SCA_XML}</MenuItem>
            ) : (
              ""
            )}
          </Select>
        </FormControl>
        <Tooltip title={t("Refresh_list")}>
          <div className="bdr-rt">
            <button className="bdr-btn" onClick={refresh}>
              <RefreshIcon
                color="#fff"
                className={manifestStatus ? "rotate" : ""}
              />
            </button>
          </div>
        </Tooltip>
        {optionManifest === MANIFEST_LIST ? (
          ""
        ) : (
          <div className="bdr-rt">
            <div className="btn-wrapper">
              <Tooltip title={t("View_as_XML")}>
                <button className={forXml ? "active" : ""} onClick={xmlHandle}>
                  {t("XML")}
                </button>
              </Tooltip>
              <Tooltip title={t("View_as_List")}>
                <button
                  className={forList ? "active" : ""}
                  onClick={listHandle}
                >
                  {t("List")}
                </button>
              </Tooltip>
            </div>
          </div>
        )}
        <Tooltip title={t("Search_Text")}>
          <div className="search-wrapper">
            <input
              type="text"
              label="Text"
              value={text}
              ref={countReference}
              placeholder="Search..(min 2 chars)"
              disabled={optionManifest ? false : true}
              onChange={(e) => setToHighlight(e.target.value)}
            />
            <SearchIcon />
          </div>
        </Tooltip>
        <Tooltip title={t("Clear_search_text")}>
          <div className="bdr-rt">
            <button className="bdr-btn" onClick={blankText}>
              <CloseIcon color="#fff" />
            </button>
          </div>
        </Tooltip>
        <a
          style={{
            opacity: optionManifest ? 1 : 0.4,
            pointerEvents: optionManifest ? "auto" : "none",
          }}
          href={
            `${process.env.REACT_APP_API_URL}/api/VisageSpa/GetManifestZip?siteId=` +
            siteId.get()
          }
          className="bdr-btn"
        >
          <DownloadIcon color="#fff" />
        </a>
        {text.length >= 2 && (
          <p style={{ color: "white" }}>{countMatch.get()} matches found</p>
        )}
      </Header>
      <Wrapper higlight={text}>
        {optionManifest === "Manifest List" && (
          <div id="zipContents">
            <Box>
              <table>
                <thead>
                  <tr>
                    <th>{t("Name")}</th>
                    <th>{t("Version")}</th>
                    <th>{t("Created_By")}</th>
                    <th>{t("Created_date_UTC")}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody id="mainManifestList">
                  {manifestListData &&
                    manifestListData?.length !== 0 &&
                    manifestListData?.map((val, key) => {
                      return (
                        <tr key={val.id}>
                          <td class="searchName">
                            {getHighlightedText1(val.Name, text)}
                          </td>
                          <td class="searchName">
                            {getHighlightedText1(val.Version.toString(), text)}
                          </td>
                          <td class="searchName">
                            {getHighlightedText1(val.CreatedByUser, text)}
                          </td>
                          <td class="searchName">
                            {getHighlightedText1(
                              moment(val.CreationDateInUtc).format(
                                "DD-MMM-YYYY HH:mm:ss"
                              ),
                              text
                            )}
                          </td>
                          <td>
                            {val.ZipContents.length === 0
                              ? ""
                              : actionButton(val)}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </Box>
            {openDismiss && (
              <Box>
                <div id="zipContents">
                  <div className="header">
                    <h2>{zoom?.ZipContents.length} Files</h2>
                    <div className="action-btn">
                      <button onClick={() => handleClose()}>
                        <CloseIcon width={20} height={20} color="#fff" />
                      </button>
                    </div>
                  </div>

                  <table>
                    <thead>
                      <tr>
                        <th>{t("Name")}</th>
                        <th>{t("Last_modified")}</th>
                      </tr>
                    </thead>
                    <tbody id="zipContents">
                      {zoom?.ZipContents &&
                        zoom?.ZipContents.length !== 0 &&
                        zoom?.ZipContents.map((val, key) => {
                          return (
                            <tr key={uuid()}>
                              <td>{getHighlightedText1(val.Name, text)}</td>
                              <td>
                                {getHighlightedText1(
                                  moment(val.LastModifiedDate).format(
                                    "DD-MMM-YYYY HH:mm:ss"
                                  ),
                                  text
                                )}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </Box>
            )}
          </div>
        )}

        {forXml && optionManifest === "SiteSettings.xml" ? (
          <div
            style={{ whiteSpace: "pre", height: "85%", overflow: "auto" }}
            higlight={text}
          >
            {getHighlightedText(getSiteSettingStateAction, text)}
          </div>
        ) : (
          ""
        )}
        {forXml && optionManifest === "Pace.xml" ? (
          <div style={{ whiteSpace: "pre", height: "85%", overflow: "auto" }}>
            {getHighlightedText(getPaceManifestStateAction, text)}
          </div>
        ) : (
          ""
        )}
        {forXml && optionManifest === "Messages.xml" ? (
          <div style={{ whiteSpace: "pre", height: "85%", overflow: "auto" }}>
            {getHighlightedText(getMessageManifestStateAction, text)}
          </div>
        ) : (
          ""
        )}
        {forXml && optionManifest === "LanguageSettings.xml" ? (
          <div style={{ whiteSpace: "pre", height: "85%", overflow: "auto" }}>
            {getHighlightedText(getLanguageManifestStateAction, text)}
          </div>
        ) : (
          ""
        )}
        {forXml && optionManifest === "SimpleCarAhead.xml" ? (
          <div style={{ whiteSpace: "pre", height: "85%", overflow: "auto" }}>
            {getHighlightedText(getSimpleCarManifestStateAction, text)}
          </div>
        ) : (
          ""
        )}

        {forList && optionManifest === "SiteSettings.xml" ? (
          <>{highlightedHTML(getSettingListState, text)}</>
        ) : (
          ""
        )}

        {forList && optionManifest === "Pace.xml" ? (
          <>{highlightedHTML(getPaceListState, text)}</>
        ) : (
          ""
        )}

        {forList && optionManifest === "Messages.xml" ? (
          <>{highlightedHTML(getMessageListState, text)}</>
        ) : (
          ""
        )}

        {forList && optionManifest === "LanguageSettings.xml" ? (
          <>{highlightedHTML(getLanguageListState, text)}</>
        ) : (
          ""
        )}

        {forList && optionManifest === "SimpleCarAhead.xml" ? (
          <>{highlightedHTML(getSimpleCarListState, text)}</>
        ) : (
          ""
        )}
      </Wrapper>
    </Container>
  );
};

export default Manifest;
